// extracted by mini-css-extract-plugin
export default {"content":"MagicMath2_content__PPDby"};